<app-expansion-list
    (onAdd)="emit_btnAddClick()"
    (onClick)="emit_onClick($event)"
    (onRestore)="emit_onRestore($event)"
    [(tabMode)]="tabMode$$"
    [btnAddData]="btnAddData$$()"
    [btnDeleteData]="btnDeleteData$$()"
    [claimPageList]="claimPageList$$()"
    [itemLines]="itemLines"
    [itemSize]="ItemSize"
    [noClick]="noClick$$()"
    [template]="template"
/>

<ng-template #template let-listItem>
    <div class="message-row">
        <div class="title-subline-row message-row__text">
            <!-- Regel 1: (domain › project ·) tijd · afzender (· organisatie). -->
            <p matListItemLine class="subline">
                @if (context_text(listItem)) {
                    <span>{{ context_text(listItem) }}</span>
                    <span>{{ text.separator }}</span>
                }
                <span>{{ listItem?.[sentOn] | appDate:'dateTime' }}</span>
                <span>{{ text.separator }}</span>
                <span>{{ sender_text(listItem) }}</span>
            </p>
            <h3 matListItemTitle [class.message-row__unread]="!listItem?.[read]">{{ listItem?.[subject] }}</h3>
            <p matListItemLine class="message-row__audience">{{ audience_text(listItem) }}</p>
        </div>
        <div class="message-row__status">
            @if (counts_text(listItem); as counts) {
                <span class="message-row__counts">{{ counts }}</span>
            }
            @if (acknowledgePending(listItem)) {
                <app-icon name="circle-exclamation" [matTooltip]="text.acknowledge" [matTooltipPosition]="'left'" />
            }
            @if (!listItem?.[read]) {
                <span class="message-row__dot" [matTooltip]="text.unread" [matTooltipPosition]="'left'"></span>
            }
        </div>
    </div>
</ng-template>
